.modalFormButtonContainer {
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    margin-top: 20px;
}

.impactProbability {
    margin-bottom: 40px;
}

.impactProbabilityCell {
    flex: 1;
}

.impactProbability {
    display: flex;
    gap: 20px;
}

.total {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-left: 40px;
}

.riskHeaderContainer {
    display: flex;
    align-items: flex-end;
}

.average {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-bottom: 40px;
}